import type { Rng } from '../../core/rng';
import { obbCorners } from '../../geo/polygon';
import type { Lot } from './types';
import { across } from './acrossPlot';
import { lotFrame } from './lotFrame';
import { lotKey } from './lotKey';

/**
 * PLAN Lots, front houses (2026-09-27): a house in the walled city stands U(5.6, 12) m deep, no
 * deeper than its lot. House depths ran 5.6-12 m: about 7 m on the Warmoesstraat (M. Hell, De
 * Amsterdamse herberg, 2017), 12 and 8.30 m on the Oudezijds Armsteeg (AAR 60; docs/plans/houses.md
 * §4.6). The lot planner draws lots up to 22 m deep; the rest of a deeper lot lies behind the house,
 * in its plot (plots.ts), for its courtyard and back buildings (backlots.ts).
 */
export const FRONT = { depth: { min: 5.6, max: 12 } } as const;

/* The draw forks on the house's name, so a house keeps its depth whatever other houses there are. */
export function toFrontDepth(house: Lot, rng: Rng): Lot {
  const drawn = rng.fork(lotKey(house)).range(FRONT.depth.min, FRONT.depth.max);
  const { depth } = lotFrame(house);
  if (drawn >= depth) return house;
  const obb = across(house, -depth, drawn - depth, 1);
  return { ...house, obb, corners: obbCorners(obb), depth: drawn };
}
